/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Employees {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { Section } from "@bw/bits"
import { Employees as EmployeesModule } from "@bw/modules"

const Employees = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  anchor,
}) => {
  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
    >
      <EmployeesModule />
    </Section>
  )
}

export { Employees }
